import React from 'react';
import {
  Menu,
  MenuItem,
  IconButton,
  Typography,
  Box,
  ListItemIcon,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemButton,
} from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';
import i18n, { t } from 'i18next'; // veya kullandığınız i18n kütüphanesi

const languageOptions = [
  { code: 'en', name: 'English', icon: '🇬🇧' },
  { code: 'tr', name: 'Türkçe', icon: '🇹🇷' },
  { code: 'de', name: 'Deutsch', icon: '🇩🇪' },
  { code: 'es', name: 'Español', icon: '🇪🇸' },
  { code: 'fr', name: 'Français', icon: '🇫🇷' },
  { code: 'it', name: 'Italiano', icon: '🇮🇹' },
  { code: 'pl', name: 'Polski', icon: '🇵🇱' },
  { code: 'cs', name: 'Čeština', icon: '🇨🇿' },
  { code: 'hu', name: 'Magyar', icon: '🇭🇺' },
];
// Aşağıdaki diller desteklenmektedir:
// English, Türkçe, Deutsch, Español, Français, Italiano, Polski, Čeština

const LanguageSelector = ({ mode = 'icon' }: { mode: 'list' | 'icon' }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lng: string) => {
    console.log('Selected language:', lng);
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng); // Seçilen dili localStorage'a kaydet
    handleClose();
    // Dil değişikliğinde sayfayı yenile (isteğe bağlı)
    // window.location.reload();
  };

  return (
    <Box>
      {mode === 'icon' ? (
        <IconButton
          aria-label="change language"
          aria-controls="language-menu"
          aria-haspopup="true"
          onClick={handleClick}
          color="inherit"
        >
          <TranslateIcon />
        </IconButton>
      ) : (
        //@ts-ignore
          <ListItemButton onClick={handleClick} sx={{ borderRadius: 1 }}>
            <ListItemAvatar>
              <TranslateIcon />
            </ListItemAvatar>
            <ListItemText primary={t("changeLanguage")}/>
          </ListItemButton>
      )}
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            width: '200px',
          },
        }}
      >
        {languageOptions.map((language) => (
          <MenuItem
            key={language.code}
            onClick={() => changeLanguage(language.code)}
            selected={i18n.language === language.code}
          >
            <ListItemIcon>
              <Typography variant="h6">{language.icon}</Typography>
            </ListItemIcon>
            <Typography variant="body1">{language.name}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageSelector;
